/**
 * Eon API
 * The Eon.io REST API
 *
 * AUTOGENERATED: Do not edit the class manually.
 * Instead edit the .mustache file and run `node --run gen-openapi`
 */

import { ApiCredentialsProperties } from '../models/ApiCredentialsProperties';
import { Pagination } from '../models/Pagination';

export class ListApiCredentialsResponse {
  'apiCredentials': Array<ApiCredentialsProperties>;
  'pagination': Pagination;

  static readonly discriminator: string | undefined = undefined;

  static readonly attributeTypeMap: Array<{name: string, baseName: string, type: string, format: string}> = [
    {
      "name": "apiCredentials",
      "baseName": "apiCredentials",
      "type": "Array<ApiCredentialsProperties>",
      "format": ""
    },
    {
      "name": "pagination",
      "baseName": "pagination",
      "type": "Pagination",
      "format": ""
    }  ];

  static getAttributeTypeMap() {
    return ListApiCredentialsResponse.attributeTypeMap;
  }

  public constructor() {
  }
}

